<p-dialog
    [visible]="visible"
    (visibleChange)="onVisibleChange($event)"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    styleClass="old-price-dialog"
    [style]="{ width: '920px' }"
    [contentStyle]="{ overflow: 'auto', padding: '0 1.1rem 1.1rem' }"
    [breakpoints]="{ '980px': '96vw' }"
    appendTo="body"
>
    <ng-template pTemplate="header">
        <div class="old-price-heading">
            <div class="old-price-heading__title">Price history</div>
            <div class="old-price-heading__sub">Past sales prices for this customer and item</div>
        </div>
    </ng-template>

    <div class="old-price-modal">
        <div class="old-price-filters">
            <label class="old-price-field old-price-field--customer">
                <span>Customer</span>
                <input pInputText [value]="customer" disabled />
            </label>
            <label class="old-price-field">
                <span>Item</span>
                <p-autoComplete
                    class="old-price-item-search"
                    [ngModel]="selectedSuggestion"
                    (ngModelChange)="onSearchModelChange($event)"
                    [suggestions]="suggestions"
                    [minLength]="3"
                    [delay]="400"
                    [forceSelection]="true"
                    [showClear]="true"
                    [dropdown]="false"
                    field="FINALRESPNSE"
                    placeholder="Search item name or number"
                    appendTo="body"
                    (completeMethod)="searchItems($event)"
                    (onSelect)="onItemSelected($event)"
                    (onClear)="clearItem()"
                ></p-autoComplete>
            </label>
            <label class="old-price-field">
                <span>Records</span>
                <select [(ngModel)]="maxRecords" (ngModelChange)="onMaxRecordsChange()" aria-label="How many prices to load">
                    <option *ngFor="let option of maxRecordOptions" [ngValue]="option.value">{{ option.label }}</option>
                </select>
            </label>
            <p-button
                label="Search"
                icon="pi pi-search"
                [disabled]="!canSearch"
                [loading]="loading"
                (onClick)="search()"
            ></p-button>
        </div>

        <p *ngIf="searchHint && !errorMessage" class="old-price-message">{{ searchHint }}</p>
        <p *ngIf="errorMessage" class="old-price-message is-error">{{ errorMessage }}</p>
        <p *ngIf="!errorMessage && searched && !loading && rows.length === 0" class="old-price-message">
            No price history found.
        </p>

        <div *ngIf="rows.length > 0" class="old-price-results">
            <div class="old-price-meta">
                <span>{{ recordLabel }}</span>
            </div>
            <p-table
                [value]="rows"
                [paginator]="rows.length > pageSize"
                [rows]="pageSize"
                [scrollable]="true"
                scrollHeight="380px"
                styleClass="old-price-table"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Order</th>
                        <th>Item description</th>
                        <th class="num">Quantity</th>
                        <th class="num">Sales price</th>
                        <th>Date</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>{{ row.orderNumber }}</td>
                        <td class="desc">{{ row.description }}</td>
                        <td class="num">{{ formatQty(row.quantity) }}</td>
                        <td class="num"><span class="old-price-chip">{{ formatPrice(row.salesPrice) }}</span></td>
                        <td>{{ formatDate(row.orderDate) }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</p-dialog>
